// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__35629","footer":"ChangeClinic_footer__3zS65"};